<template>
  <a-row>
    <a-col :span="24">
      <a-alert v-if="submitStatus === 1" message="Saving" type="info" show-icon/>
      <a-alert v-else-if="submitStatus === 2" message="Thanks. The areas you service have been updated." type="success" show-icon/>
      <a-alert v-else-if="submitStatus === 3" message="Error" type="error" show-icon/>
      <br/>
      <a-form-model layout="horizontal" :model="form" v-bind="formItemLayout">
        <a-form-model-item
            v-for="region in toRegions"
            :key="region.id"
            :label="`${fromRegion.name} => ${region.name}`">
          <a-skeleton :loading="isLoading" active :title="{ width: 400 }" :paragraph="{ rows: 0 }"/>
          <a-slider
              v-if="!isLoading"
              v-model="form[region.id]"
              :min="0"
              :max="100"
              :step="null"
              :marks="marks"
              :default-value="0"
              :tip-formatter="formatter"
              @afterChange="value =>handleAfterChange(value, fromRegion.id, region.id)" />
        </a-form-model-item>
      </a-form-model>
    </a-col>
  </a-row>
</template>

<script>
export default {
  name: "ServiceRegion",
  props: {
    fromRegion: {
      type: Object,
      required: true,
    },
    toRegions: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      marks: {
        0: 'Never',
        50: 'Sometimes',
        100: 'Always',
      },
      form: {
      },
      submittedForm: {
      },
      isLoading: false,
      submitStatus: 0,
    };
  },
  methods: {
    handleAfterChange(value, fromId, toId) {
      const originVal = this.getSubmittedForm(toId);
      console.log(originVal);
      if (originVal === value) {
        return;
      }
      this.form[toId] = value;
      this.submitStatus = 1;
      axios.post('/carry-freight/service-region/' + fromId, {
        to_region_id: toId,
        service_level: value,
      })
      .then(res => {
        console.log(res);
        this.submitStatus = 2;
        this.setSubmittedForm(toId, value);
      })
      .catch(err => {
        console.log(err.response);
        this.form[toId] = originVal;
        this.submitStatus = 3;
      });
    },
    mapToForm(regions) {
      regions.forEach(region => {
        const form = {...this.form};
        form[region.to_region_id] = region.service_level;
        this.form = form;

        const submittedForm = {...this.submittedForm};
        submittedForm[region.to_region_id] = region.service_level;
        this.submittedForm = submittedForm;
      })
    },
    setSubmittedForm(regionId, serviceLevel) {
      const form = {...this.submittedForm};
      form[regionId] = serviceLevel;
      this.submittedForm = form;
    },
    getSubmittedForm(regionId) {
      const form = {...this.submittedForm};
      return form[regionId];
    },
    formatter(value) {
      if (this.marks.hasOwnProperty(value)) {
        return this.marks[value];
      }
      return null;
    },
    load() {
      this.isLoading = true;
      axios.get('/carry-freight/service-region/' + this.fromRegion.id)
        .then(res => {
          console.log(res);
          this.mapToForm(res.data);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => this.isLoading = false);
    },
  },
  computed: {
    formItemLayout() {
      return {
        labelCol: { span: 9 },
        wrapperCol: { span: 12, offset: 1 },
      };
    },
  },
  mounted() {
    this.load();
  }
}
</script>

<style scoped>

</style>
